<template>
  <sc-page-base
    title="Performance por Transportadora"
    :loading="loading">

    <sc-grid
      :name="$options.name"
      :data="reportData.items"
      :total="reportData.total"
      :default-filters="defaultFilters"
      @submit="config"
      @pagination="config"
      @sorting="config">

      <template slot="filters" slot-scope="{ filters }">
        <sc-report-provider-filters :filters="filters"/>
      </template>

      <template
        slot="after-filters"
        v-if="reportData.total">
        <div class="box">
          <sc-chart-provider-ship-state />
        </div>

        <div class="box">
          <sc-chart-provider-ship-state-percent />
        </div>

        <div class="box">
          <div class="columns">
            <div class="column is-12-mobile">
              <sc-chart-provider-ship-orders />
            </div>
            <div class="column is-12-mobile is-one-third-widescreen">
              <sc-chart-provider-orders />
            </div>
          </div>
        </div>
      </template>

      <template
        slot="before-table"
        v-if="reportData.total">
        <div class="buttons">
          <sc-button
            theme="primary"
            :loading="exportLoading"
            text="Exportar para o Excel"
            icon="file-excel"
            @click="exportPerformanceProviderReport(reportConfig)"/>
        </div>
      </template>

      <template
        slot="table-columns"
        slot-scope="{ props }">

        <sc-table-column
          field="shipping_first_name"
          label="Nome"
          sortable>
          {{ props.row.shipping_first_name }} {{ props.row.shipping_last_name }}
        </sc-table-column>

        <sc-table-column
          field="delivery_method_name"
          label="Método de entrega"
          sortable>
          {{ props.row.delivery_method_name }}
        </sc-table-column>

        <sc-table-column
          field="estimated_delivery_date_lp_iso"
          label="Estimativa de entrega"
          sortable>
          {{ props.row.estimated_delivery_date_lp_iso | date('DD/MM/YYYY') }}
        </sc-table-column>

        <sc-table-column
          field="delivered_date_iso"
          label="Data de entrega"
          sortable>
          {{ props.row.delivered_date_iso | date('DD/MM/YYYY') }}
        </sc-table-column>

        <sc-table-column
          field="delivery_method_name"
          label="Performance"
          sortable>
          <span
            class="tag is-primary"
            v-if="!props.row.delivered_late_lp">No prazo</span>
          <span
            class="tag is-danger"
            v-if="props.row.delivered_late_lp">Atrasado</span>
        </sc-table-column>

        <sc-table-column
          field="shipping_state"
          label="UF"
          sortable>
          {{ props.row.shipping_state }}
        </sc-table-column>
      </template>

    </sc-grid>
  </sc-page-base>
</template>

<script>
  import { Moment } from '@intelipost-js/secure-providers';
  import {
    ScPageBase,
    ScGrid,
    ScButton,
    ScTableColumn,
    ScCard,
  } from '@intelipost-js/secure-components';
  import { createNamespacedHelpers } from 'vuex';

  import ScReportProviderFilters from './components/sc-report-provider-filters/ScReportProviderFilters';
  import ScChartProviderShipState from './components/sc-chart-provider-ship-state/ScChartProviderShipState';
  import ScChartProviderShipStatePercent from './components/sc-chart-provider-ship-state-percent/ScChartProviderShipStatePercent';
  import ScChartProviderOrders from './components/sc-chart-provider-orders/ScChartProviderOrders';
  import ScChartProviderShipOrders from './components/sc-chart-provider-ship-orders/ScChartProviderShipOrders';

  const { mapState, mapActions } = createNamespacedHelpers('analytic/provider');

  export default {
    name: 'page-report-provider',
    data() {
      return {
        reportConfig: {},
        defaultFilters: {
          occurrence: null,
          logistic_provider_id: null,
          date_type: 'CREATED_DATE',
          dateRange: {
            start: Moment().subtract(1, 'days').format('YYYY-MM-DD'),
            end: Moment().format('YYYY-MM-DD'),
          },
        },
      };
    },
    computed: {
      ...mapState([
        'loading',
        'exportLoading',
        'reportData',
        'chartDeliveredOrders',
      ]),
    },
    methods: {
      ...mapActions([
        'generateReport',
        'exportPerformanceProviderReport',
      ]),
      config(config) {
        this.reportConfig = config;

        if (config.filters.logistic_provider_id) {
          this.generateReport(config);
        }
      },
    },
    components: {
      ScPageBase,
      ScGrid,
      ScButton,
      ScTableColumn,
      ScCard,
      ScReportProviderFilters,
      ScChartProviderShipState,
      ScChartProviderShipStatePercent,
      ScChartProviderOrders,
      ScChartProviderShipOrders,
    },
  };
</script>


// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-analytic/features/reports/pages/provider/PageReportProvider.vue?2e1faa06